import React from "react";
import SectionTitle from "../../components/layouts/others/title-section.layout";
import {
    Box,
    Container,
    Typography,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Paper,
    Stack,
    Alert,
    Grid, Button, Avatar
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faInfoCircle, faCircle, faExternalLinkAlt, faFilePdf} from "@fortawesome/free-solid-svg-icons";
// @ts-ignore
import oldLogo from "../../assets/images/logo/logo-old.png";
// @ts-ignore
import imgBefore1 from "../../assets/images/articles/2025-04-11/letter-before-1.png"
// @ts-ignore
import imgAfter1 from "../../assets/images/articles/2025-04-11/letter-after-1.png"
// @ts-ignore
import img1 from "../../assets/images/articles/2025-04-11/letter-img-1.png"
// @ts-ignore
import imgBefore2 from "../../assets/images/articles/2025-04-11/letter-before-2.png"
// @ts-ignore
import imgAfter2 from "../../assets/images/articles/2025-04-11/letter-after-2.png"
// @ts-ignore
import img2 from "../../assets/images/articles/2025-04-11/letter-img-2.png"
// @ts-ignore
import img3 from "../../assets/images/articles/2025-04-11/letter-img-3.png"
// @ts-ignore
import imgBefore3 from "../../assets/images/articles/2025-04-11/letter-before-3.png"
// @ts-ignore
import imgAfter3 from "../../assets/images/articles/2025-04-11/letter-after-3.png"
// @ts-ignore
import imgBefore4 from "../../assets/images/articles/2025-04-11/letter-before-4.png"
// @ts-ignore
import imgAfter4 from "../../assets/images/articles/2025-04-11/letter-after-4.png"
// @ts-ignore
import img4 from "../../assets/images/articles/2025-04-11/letter-img-4.png"
// @ts-ignore
import photoJpg from "../../assets/images/others/jpg.png"

const ARTICLE20250411: React.FC = () => {
    return (
        <Container maxWidth="lg" sx={{ mb: 6 }}>
            <SectionTitle title="ESPACE INFORMATIONS DES HABITANTS" />
            <Stack spacing={3}>
                <Box textAlign="center">
                    <img
                        src={oldLogo}
                        alt="Association Vivre la démocratie à BLR"
                        style={{ width: 300, marginBottom: 10, marginTop: 10 }}
                    />
                    <Typography
                        variant="h5"
                        color="primary"
                        fontWeight={700}
                        gutterBottom
                        sx={{ pt: 1, pb: 1 }}
                    >
                        Contribution de l’association à l’enquête publique sur le PLUi
                    </Typography>
                </Box>
                <Divider />

                <Box>
                    <Typography variant="h6" gutterBottom>
                        Madame la Présidente de la Commission d’Enquête, Madame et Monsieur les Commissaires,
                    </Typography>
                    <Typography>
                        L'association Vivre la démocratie à BLR a été créée pour informer les habitants, fédérer les initiatives locales et agir concrètement pour préserver la qualité de vie à Bois-le-Roi et y faire vivre la démocratie. Nous sommes attachés aux valeurs républicaines, à la liberté d'expression et au respect des opinions.
                    </Typography>
                    <Typography>
                        Depuis sa création, l’association a rédigé en son nom propre ou avec d’autres, plus de quarante bulletins d’information sur les thèmes suivants : l’urbanisme, et particulièrement sur le PLUi, mais aussi le cadre de vie, la démocratie, les équipements sportifs, la construction d’une crèche.
                    </Typography>
                    <Typography>
                        Malgré ce qu’en dit l’équipe municipale, il n'y a pas réellement eu de concertation lors de l’élaboration du PLUi, ou alors à la marge sur des généralités ou des détails du règlement écrit.
                    </Typography>
                    <Typography>
                        Ce sont des « balades paysagères » en mai 2022 dans des secteurs à préserver, un atelier participatif en décembre 2022 sur le thème du développement durable, des groupes de travail en 2024 sur des détails mais jamais sur des règles concrètes et jamais autour de « l’intention » politique.
                    </Typography>
                    <Alert severity="warning" icon={<FontAwesomeIcon icon={faInfoCircle} />} sx={{ mt: 3 }}>
                        <b>Nous dénonçons une concertation biaisée et orientée.</b>
                    </Alert>
                    <Typography sx={{ mt: 2 }}>
                        C’est par exemple à l’occasion de la réunion publique du 15 juin 2024, que le Maire et son équipe municipale ont dévoilé le recours aux Secteurs de Mixité Sociale (SMS) et ont présenté la vingtaine de secteurs retenus sur lesquels il sera imposé pour toute construction, 80%* de logements sociaux (LS) dès le premier logement construit. <i>*avec arrondi à l’unité supérieure</i>
                    </Typography>
                </Box>

                <Paper elevation={1} sx={{ p: 2, background: "#f7f7f9" }}>
                    <Typography variant="subtitle2" color="textSecondary">
                        Le « secteur de mixité sociale » défini à l’article L151-15 du Code de l’Urbanisme est un périmètre au sein duquel tout programme d’habitat devra comprendre un pourcentage affecté à une catégorie de logements sociaux (LS) en vue d’atteindre des objectifs de mixité sociale. Cette servitude permet d’aider les communes et les EPCI à atteindre les objectifs de mixité sociale, en leur laissant le soin de définir le pourcentage à réserver aux LS.
                    </Typography>
                </Paper>

                <Stack spacing={2}>
                    <Typography>
                        Le Maire exploite ce dispositif dans sa version la plus coercitive possible, puisqu’il va jusqu’à interdire aux propriétaires de ces parcelles la possibilité de pouvoir y construire leurs propres maisons.
                    </Typography>
                    <Typography>
                        Les propriétaires concernés n’ont même pas été prévenus au préalable par l’équipe municipale.
                    </Typography>
                    <Alert severity="error" icon={<FontAwesomeIcon icon={faInfoCircle} />}>
                        <b>Les SMS tels qu’ils ont été définis par le Maire sont une atteinte inacceptable au droit de la propriété.</b>
                    </Alert>
                    <Alert severity="error" icon={<FontAwesomeIcon icon={faInfoCircle} />}>
                        <b>Nous nous opposons à cette décision brutale qui ne correspond pas à nos valeurs !</b>
                    </Alert>
                    <Typography>
                        Qui voudrait racheter une parcelle sachant qu’il n’est pas possible d’y faire construire sa maison ? Personne, ou alors au prix du non constructible.
                    </Typography>
                    <Typography>
                        Nous avions demandé une modification de la réglementation de ces secteurs de mixité sociale pour permettre a minima aux propriétaires concernés de pouvoir y construire leurs propres habitations. (Cf. notre Lettre d’informations 40 du 24/08/2024 sur le PLUi)
                    </Typography>
                    <Typography>
                        En plus des deux secteurs à construire du programme local de l’habitat (PLH) (Focel et Gare), de l’OAP des Sesçois, le Maire a intégré au PLUi une règle qui s’appliquera sur l’ensemble de la commune pour les logements collectifs à construire : 3 à 15 logements envisagés = 80%* de LS obligatoire, et 75%* si plus de 16 logements.
                    </Typography>
                    <Typography>
                        <b>Malgré la perte de capacité financière de la commune, le Maire n’avait pas besoin de spolier des propriétaires pour aller dans le sens de la loi SRU.</b>
                    </Typography>
                    <Typography>
                        Nous vous demandons de rendre un avis défavorable aux SMS (délimités au règlement graphique) tels qu’ils sont souhaités par le Maire.
                    </Typography>
                    <Typography>
                        En complément, nous ne nous opposons pas à la règle rappelée précédemment, obligeant la réalisation de logements sociaux pour toute nouvelle construction de logements collectifs, néanmoins par cohérence et afin d’éviter d’aggraver notre dette en termes de logements SRU, nous proposons que cette règle s’applique également aux divisions de logements existants.
                    </Typography>
                    <Typography>
                        Au-delà de cette demande prioritaire, nous souhaitons vous faire part des demandes d’évolutions suivantes :
                    </Typography>
                </Stack>

                <List dense sx={{ pl: 2 }}>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="Mentionner dans le règlement écrit la largeur de la bande constructible de 30m depuis la voie pour chaque zone. La représentation graphique ne suffit pas." />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="En zone UAv, réduire l’emprise au sol des constructions à 50% maximum et augmenter les surfaces minimales de pleine terre végétalisée." />
                    </ListItem>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="En zone UBa, fixer le recul d’implantation du bâti à 6m (comme actuellement dans la zone UB) ou l’obligation d’implanter les constructions nouvelles dans la continuité du bâti existant." />
                    </ListItem>
                </List>

                <Typography>
                    Plus de 20 rues sont concernées par un changement de zone de UB : UBa.
                    [Zone UB] recul d'implantation : 6 m par rapport à la voie
                    [Zone UBa] recul d’implantation : Alignement sur la voie ou 3 m par rapport à la voie
                </Typography>

                <List dense sx={{ pl: 2 }}>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="Dans l’OAP N°2 : QUARTIER GARE - AVENUE GALLIENI, diminuer de 75 % à 50% la proportion de logements sociaux “SRU” à construire." />
                    </ListItem>
                </List>

                <Typography>
                    Il s’agit de rechercher une réelle mixité sociale. Compte tenu des parcelles à fort potentiel qui pourraient être concernées (La Poste, Garage automobile, etc…), un pourcentage trop important pourrait avoir l’effet inverse à celui recherché avec un quartier quasi exclusivement social.
                </Typography>

                <List dense sx={{ pl: 2 }}>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="Étendre la protection « Espace vert protégé aménageable » aux propriétés du quai de la Ruelle non protégées par une autre protection comme pour le quai Métra et rétablir les protections des deux grandes parcelles situées entre le Port Baquin et le Clos Barbeau passées en zonage Ud constructible dans le PLUi." />
                    </ListItem>
                </List>

                <Typography>
                    Il s’agit d’une régression par rapport au PLU actuel ; des parcelles deviennent constructibles. Le bord de Seine de Bois-le-Roi avec ses « Affolantes », est un patrimoine à protéger dans son ensemble.
                </Typography>

                <List dense sx={{ pl: 2 }}>
                    <ListItem>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                        </ListItemIcon>
                        <ListItemText primary="Positionner en zone Nj ou autre protection les terrains de la rue du buisson Cheydau actuellement protégé par « Terrain cultivé à protéger », et ajouter une protection pour les murs de clôture." />
                    </ListItem>
                </List>

                <Typography>
                    Il s’agit d’une régression par rapport au PLU actuel.
                </Typography>
            </Stack>
            <Grid container spacing={3} sx={{ pt: 3 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "primary.main",
                                background: "rgba(25, 118, 210, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Avant
                        </Typography>
                        <Box
                            component="img"
                            src={imgBefore1}
                            alt="Avant"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "success.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Après
                        </Typography>
                        <Box
                            component="img"
                            src={imgAfter1}
                            alt="Après"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12 }} sx={{ paddingTop: 3 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            paddingTop: 1,
                            paddingBottom: 1,
                            paddingLeft: 3,
                            paddingRight: 3,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "secondary.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Photographie de la rue du buisson Cheydau (Google Maps)
                        </Typography>
                        <Box
                            component="img"
                            src={img1}
                            alt="Photographie de la rue"
                            sx={{
                                width: "100%",
                                height: 360,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <List dense sx={{ marginTop: 4, pl: 2 }}>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText primary="Rétablir la protection du mur d’enceinte du cimetière." />
                </ListItem>
            </List>
            <Typography>
                Il s’agit d’une régression par rapport au PLU actuel.
            </Typography>
            <Grid container spacing={3} sx={{ pt: 3 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "primary.main",
                                background: "rgba(25, 118, 210, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Avant
                        </Typography>
                        <Box
                            component="img"
                            src={imgBefore2}
                            alt="Avant"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "success.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Après
                        </Typography>
                        <Box
                            component="img"
                            src={imgAfter2}
                            alt="Après"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12 }} sx={{ paddingTop: 3 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            paddingTop: 1,
                            paddingBottom: 1,
                            paddingLeft: 3,
                            paddingRight: 3,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "secondary.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Photographie du mur du cimetière (Google Maps)
                        </Typography>
                        <Box
                            component="img"
                            src={img2}
                            alt="Photographie de la rue"
                            sx={{
                                width: "100%",
                                height: 360,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <List dense sx={{ marginTop: 4, pl: 2 }}>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText primary="Rétablir la protection du mur de clôture rue aux loups." />
                </ListItem>
            </List>
            <Typography>
                Il s’agit d’une régression par rapport au PLU actuel.
            </Typography>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }} sx={{ paddingTop: 3 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            paddingTop: 1,
                            paddingBottom: 1,
                            paddingLeft: 3,
                            paddingRight: 3,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "secondary.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Photographie du mur de la rue aux loups (Google Maps)
                        </Typography>
                        <Box
                            component="img"
                            src={img3}
                            alt="Photographie de la rue"
                            sx={{
                                width: "100%",
                                height: 360,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <List dense sx={{ marginTop: 4, pl: 2 }}>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText primary="Rétablir une protection sur la parcelle du 10 rue de l’Ile St Pierre (perte de la protection EBC), par exemple “Espace vert protégé aménageable”, une construction de taille importante est possible (zone UBb1)." />
                </ListItem>
            </List>
            <Grid container spacing={3} sx={{ pt: 3 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "primary.main",
                                background: "rgba(25, 118, 210, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Avant
                        </Typography>
                        <Box
                            component="img"
                            src={imgBefore3}
                            alt="Avant"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "success.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Après
                        </Typography>
                        <Box
                            component="img"
                            src={imgAfter3}
                            alt="Après"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <Typography sx={{ paddingTop: 5 }}>
                Maintenir la double protection de nombreuses parcelles : “Protection forestière” + “EBC” dans le PLU. Ces parcelles, pour une surface totale de l’ordre d’une centaine d'hectares, la plupart situées en périphérie de la commune, perdent la protection EBC dans le PLUi. Pourquoi?
            </Typography>
            <Typography>
                Exemple :
            </Typography>
            <Grid container spacing={3} sx={{ pt: 3 }}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "primary.main",
                                background: "rgba(25, 118, 210, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Avant
                        </Typography>
                        <Box
                            component="img"
                            src={imgBefore4}
                            alt="Avant"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <Paper
                        elevation={4}
                        sx={{
                            borderRadius: 3,
                            p: 1,
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 },
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            height: "100%",
                        }}
                    >
                        <Typography
                            variant="overline"
                            sx={{
                                letterSpacing: 2,
                                color: "success.main",
                                background: "rgba(46, 125, 50, 0.10)",
                                px: 2,
                                py: 0.2,
                                borderRadius: 2,
                                fontWeight: 700,
                                mb: 1,
                            }}
                        >
                            Après
                        </Typography>
                        <Box
                            component="img"
                            src={imgAfter4}
                            alt="Après"
                            sx={{
                                width: 240,
                                height: 180,
                                maxWidth: "100%",
                                borderRadius: 2,
                                objectFit: "cover",
                                boxShadow: 3,
                                display: "block",
                            }}
                        />
                    </Paper>
                </Grid>
            </Grid>
            <List dense sx={{ marginTop: 4, pl: 2 }}>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText primary="Faire figurer : sources, rus, mares, etc... Et les protéger explicitement dans le règlement graphique les zones humides : trames bleues, nappes..." />
                </ListItem>
                <ListItem>
                    <ListItemIcon>
                        <FontAwesomeIcon icon={faCircle} size="2xs" style={{ color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText primary="Revoir totalement la liste des continuités écologiques, en partant de la proposition de l’association TPAMPB et sans oublier toutes les connexions avec la forêt de Fontainebleau. Ces dernières ne figurent pas sur le document ci-dessous :" />
                </ListItem>
            </List>
            <Typography>
                Il manque notamment dans le PLUi un corridor sur la zone située entre les rues Castellani, des Grès, l’allée des noisetiers et la rue Auguste Frot, et toutes les trames liées à la forêt.
            </Typography>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12 }} sx={{ paddingTop: 3 }}>
                    <Box
                        component="img"
                        src={img4}
                        alt="Photographie de la rue"
                        sx={{
                            width: "100%",
                            height: 480,
                            maxWidth: "100%",
                            borderRadius: 2,
                            objectFit: "fit",
                            boxShadow: 3,
                            display: "block",
                            transition: "box-shadow 0.3s",
                            "&:hover": { boxShadow: 8 }
                        }}
                    />
                </Grid>
            </Grid>
            <Paper
                elevation={3}
                sx={{
                    p: 3,
                    borderRadius: 4,
                    background: "rgba(240,248,255,0.95)",
                    boxShadow: 3,
                    marginTop: 5
                }}
            >
                <Typography variant="body1" sx={{ color: "text.secondary", mb: 2 }}>
                    La survenue d'événements climatiques inédits, de plus en plus fréquents (canicule, sécheresse, inondations, incendies, etc) ne serait qu’un avant-goût des profonds changements climatiques enclenchés.
                </Typography>
                <Box
                    sx={{
                        borderLeft: "4px solid #1976d2",
                        pl: 2,
                        my: 2,
                    }}
                >
                    <Typography variant="body2" sx={{ fontStyle: "italic", color: "primary.dark" }}>
                        « On sait qu'on va être plus exposés mais on n'a pas quantifié la vulnérabilité des activités ou des populations »
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.disabled", display: "block", mt: 1 }}>
                        — Sophie Lavaud, rédactrice du rapport de l'OCDE à l’ AFP (17/03/2025)
                    </Typography>
                </Box>
                <Box display="flex" justifyContent="center" mt={3}>
                    <Button
                        variant="contained"
                        href="https://www.laprovence.com/article/ecoplanete/95792764778403/episodes-de-secheresse-intense-lile-de-france-menacee-a-terme-alerte-locde"
                        target="_blank"
                        startIcon={<FontAwesomeIcon icon={faExternalLinkAlt} />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            px: 3,
                            py: 1.3,
                            boxShadow: '0px 4px 6px rgba(0,0,0,0.10)',
                            borderRadius: '8px',
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            fontSize: '1rem',
                            background: "#1565c0",
                            color: "#fff",
                            '&:hover': {
                                background: "#003c8f",
                                transform: 'scale(1.05)',
                                boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.18)',
                            },
                        }}
                    >
                        Lire l'article sur La Provence
                    </Button>
                </Box>
            </Paper>
            <Paper
                elevation={3}
                sx={{
                    marginTop: 5,
                    p: 3,
                    borderRadius: 4,
                    background: "rgba(255, 248, 235, 0.97)",
                    boxShadow: 3
                }}
            >
                <Typography variant="body1" sx={{ color: "text.primary", mb: 2 }}>
                    Bois-le-Roi bénéficie d'un patrimoine naturel remarquable entre Seine et forêt&nbsp;: biodiversité, trames écologiques, sources d'eau et nombreux espaces boisés au cœur du village. Un privilège pour la qualité de vie des habitants, mais aussi un formidable atout qu'il nous faut préserver pour appréhender dans les meilleures conditions les changements climatiques annoncés.
                </Typography>
                <Typography variant="body1" sx={{ color: "text.primary", mb: 2 }}>
                    Mais Bois-Le-Roi est soumis à des <b>risques hydrogéologiques</b> connus mais non quantifiés&nbsp;: remontée de nappes phréatiques, retrait-gonflement des argiles accentué par les épisodes de sécheresse sévères, inondations avec coulées de boue, et mouvements de terrains.
                    <br />
                    Il convient de préciser que ces deux derniers risques sont identifiés comme <b style={{ color: "#FF9800" }}>risques majeurs</b> dans le <b>DICRIM</b>.
                </Typography>
                <Box display="flex" justifyContent="center" mt={3}>
                    <Button
                        variant="contained"
                        href="https://files.georisques.fr/DICRIM/DICRIM_77037.pdf"
                        target="_blank"
                        startIcon={<FontAwesomeIcon icon={faFilePdf} />}
                        sx={{
                            textTransform: 'none',
                            fontWeight: 'bold',
                            px: 3,
                            py: 1.3,
                            boxShadow: 3,
                            borderRadius: '8px',
                            fontSize: '1rem',
                            background: "#fb8c00",
                            color: "#fff",
                            transition: 'transform 0.2s, box-shadow 0.2s',
                            '&:hover': {
                                background: "#e65100",
                                transform: 'scale(1.05)',
                                boxShadow: '0px 6px 12px rgba(255, 152, 0, 0.18)',
                            },
                        }}
                    >
                        Document PDF sur les Géorisques
                    </Button>
                </Box>
                <Typography variant="body1" sx={{ mb: 2, marginTop: 3 }}>
                    La présence de nombreuses nappes phréatiques et de circulations d’eau souterraines à faible profondeur, bien connues des habitants, constitue un facteur favorable au phénomène de retrait-gonflement des veines d’argile. Celles-ci traversent la commune de Bois-le-Roi.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Pourtant, à notre connaissance, aucune étude sur les réseaux hydrologiques de la commune de Bois-le-Roi n’a été réalisée, ni même envisagée par la municipalité, malgré nos demandes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Le document du PLUi “5i-OAP-thematique-bioclimatique-et-risques” reste à compléter, commune par commune.
                </Typography>
            </Paper>
            <Paper
                elevation={2}
                sx={{
                    p: { xs: 2, md: 5 },
                    borderRadius: 5,
                    background: "rgba(250,252,255,0.96)",
                    marginTop: 5
                }}
            >
                <Typography variant="body1" sx={{ mb: 2 }}>
                    En juin 2022, lors du projet de construction de la crèche sur le Bois de la source, nous avions alerté sur le risque hydrogéologique, conséquence d'une nouvelle artificialisation du secteur de la gare. Après la réalisation du parking rue des Sesçois (2019), une nouvelle artificialisation de ce secteur aurait pu déstabiliser l’équilibre hydrogéologique déjà fragile de toute la zone en forte pente de la ligne de chemin de fer jusqu'à la Seine. Ce risque est pourtant connu ; nous en avions eu un aperçu en contrebas, avec un mur qui s'est récemment effondré rue de Seine. Nous avions demandé qu’une étude hydrogéologique préalable soit réalisée ; le principe de précaution devrait prévaloir pour des raisons évidentes de sécurité des personnes, des biens et des infrastructures communales.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Nous proposons d’intégrer au PLUi un plan pour limiter l’artificialisation des sols et une feuille de route pour atteindre le Zéro Artificialisation Nette (ZAN) en 2050, commune par commune, et non pas à l’échelle de la CAPF.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Nous demandons d’intégrer les zones humides dans le PLUi pour les préserver.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Nous demandons que les zones à risque hydrogéologique soient explicitement identifiées dans le règlement écrit et graphique comme inconstructibles. Ce qui suppose au préalable qu'une étude hydrogéologique soit réalisée sur toute la commune de Bois-le-Roi.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Considérant nos observations, celles remontées par les autres associations, les habitants, considérant le manque de transparence et de concertation lors de la préparation de ce PLUi, considérant les enjeux majeurs pour l’avenir de notre commune et de la Communauté d’agglomération du Pays de Fontainebleau, nous pensons qu’il serait souhaitable que le PLUi soit revu avec une démarche réellement participative afin d’aboutir à un PLUi respectueux de notre environnement, de notre cadre de vie et de notre patrimoine.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, fontWeight: "medium", color: "primary.main" }}>
                    Nous vous remercions de bien vouloir soutenir cette idée dans les conclusions de vos avis.
                </Typography>
                <Typography variant="body1" sx={{ mt: 4, color: "text.secondary" }}>
                    Merci pour le temps que vous aurez consacré à l’étude de notre contribution.<br /><br />
                    Nous vous prions d’agréer, Madame la Présidente, Madame et Monsieur les Commissaires, l’expression de notre considération distinguée.
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="center" mt={6}>
                    <Avatar
                        src={photoJpg}
                        alt="Photo de Jean-Philippe GUIBERT"
                        sx={{
                            width: 192,
                            height: 192,
                            boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
                        }}
                    />
                    <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                        Jean-Philippe GUIBERT
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        sx={{
                            mt: 1,
                            fontStyle: "italic",
                            color: "text.secondary",
                            textAlign: "center",
                        }}
                    >
                        Président de l'association Vivre la Démocratie à Bois-le-Roi
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default ARTICLE20250411;